import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import LandingHeader from './LandingHeader';
import LandingFooter from './LandingFooter';
import AOS from 'aos';
import 'aos/dist/aos.css';

const LandingLayout: React.FC = () => {
  // Sync ?language param to localStorage BEFORE children render so every
  // child's useState initializer already sees the correct locale.
  const _langParam = new URLSearchParams(window.location.search).get('language');
  if (_langParam === 'ar' || _langParam === 'en') {
    localStorage.setItem('locale', _langParam);
  }

  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 1000,
      delay: 300,
    });

    // Set body attributes (className resets classes, so re-apply dir afterwards)
    document.body.id = 'kt_body';
    document.body.setAttribute('data-bs-spy', 'scroll');
    document.body.setAttribute('data-bs-target', '#kt_landing_menu');
    document.body.className = 'bg-white position-relative app-blank';

    const locale = localStorage.getItem('locale') || 'en';
    document.body.setAttribute('dir', locale === 'ar' ? 'rtl' : 'ltr');
    if (locale === 'ar') {
      document.body.classList.add('rtl');
    }

    // Remove ?language from URL now that it has been applied
    const sp = new URLSearchParams(window.location.search);
    if (sp.has('language')) {
      sp.delete('language');
      const clean = window.location.pathname + (sp.toString() ? '?' + sp.toString() : '') + window.location.hash;
      window.history.replaceState({}, '', clean);
    }

    return () => {};
  }, []);

  return (
    <div className="" id="kt_app_root">
      <div className="mb-0" id="home">
        <div className="bgi-no-repeat bgi-size-contain bgi-position-x-center bgi-position-y-bottom landing-light-bg">
          <LandingHeader />
        </div>
      </div>
      <Outlet />
      <div id="kt_scrolltop" className="scrolltop bg-base" data-kt-scrolltop="true" style={{ cursor: 'pointer', display: 'none' }}>
        <span className="svg-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.5" x="13" y="6" width="13" height="2" rx="1" transform="rotate(90 13 6)" fill="currentColor" />
            <path d="M12.5657 8.56569L16.75 12.75C17.1642 13.1642 17.8358 13.1642 18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25L12.7071 5.70711C12.3166 5.31658 11.6834 5.31658 11.2929 5.70711L5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75C6.16421 13.1642 6.83579 13.1642 7.25 12.75L11.4343 8.56569C11.7467 8.25327 12.2533 8.25327 12.5657 8.56569Z" fill="currentColor" />
          </svg>
        </span>
      </div>
    </div>
  );
};

export default LandingLayout;
















